import { FC } from "react";
import { NetworkCoverageMapMembershipType } from "@app/projects/network-assessment/maps/network-coverage-map/enumerators";
import { QESSelect } from "@app/shared/qes-standards/forms/Select";

interface NetworkCoverageMapMembershipTypeFilterProps {
  readonly membershipType: NetworkCoverageMapMembershipType;
  readonly setMembershipType: (value: NetworkCoverageMapMembershipType) => void;
  readonly primaryMembershipAlias?: string;
  readonly secondaryMembershipAlias?: string;
}

const NetworkCoverageMapMembershipTypeFilter: FC<NetworkCoverageMapMembershipTypeFilterProps> = (props: NetworkCoverageMapMembershipTypeFilterProps) => {
  const { membershipType, setMembershipType, primaryMembershipAlias, secondaryMembershipAlias } = props;

  const membershipTypeDisplay: Record<NetworkCoverageMapMembershipType, string> = {
    [NetworkCoverageMapMembershipType.Primary]: primaryMembershipAlias || "Primary",
    [NetworkCoverageMapMembershipType.Secondary]: secondaryMembershipAlias || "Secondary",
  };

  return (
    <QESSelect
      label="Membership Type"
      testId="network-coverage-map__filter--membership-type"
      value={membershipType}
      onChange={(e) => setMembershipType(e.target.value as NetworkCoverageMapMembershipType)}
      className="network-coverage-map__filter-membership-type"
    >
      {Object.values(NetworkCoverageMapMembershipType).map((m) => (
        <option
          key={`network-coverage-map__filter--membership-type-option--${m}`}
          data-testid={`network-coverage-map__filter--membership-type-option--${m}`}
          value={m}
        >
          {membershipTypeDisplay[m]}
        </option>
      ))}
    </QESSelect>
  );
};

export default NetworkCoverageMapMembershipTypeFilter;
